export var MemberContactMethod;
(function(MemberContactMethod) {
    MemberContactMethod[/**
     * SMS
     */ "Sms"] = "Sms";
    MemberContactMethod[/**
     * Email
     */ "Email"] = "Email";
    MemberContactMethod[/**
     * Mail
     */ "Mail"] = "Mail";
    MemberContactMethod[/**
     * Phone
     */ "Phone"] = "Phone";
    MemberContactMethod[/**
     * Fax
     */ "Fax"] = "Fax";
})(MemberContactMethod || (MemberContactMethod = {}));

//# sourceMappingURL=member-contact-method.js.map